import { femaleQuestionMedium, maleQuestionMedium, bulbMedium } from '@/assets/icons';

const FIVE_WHYS = `
<h2 class="basic-sub-title">
  Identificar la causa raíz
</h2>
<p>
  La herramienta de los "cinco por qué" se utiliza para la resolución de problemas, ya que permite determinar la causa raíz de un problema.
  Identificar la causa raíz de un problema permite al equipo planificar acciones correctivas
  eficaces para eliminar definitivamente la causa raíz del problema. Eliminar la causa raíz debería
  impedir cualquier posible <strong>recurrencia del problema</strong>, aunque esto implique tomarse el tiempo de buscarla previamente.<br>
</p>
<br>
<div class="ia-sensei-question">
  <div class="question-decoration"></div>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${femaleQuestionMedium}"></path></svg>
  <span class="question">De acuerdo, pero si se produce un problema durante la producción, es preciso resolverlo inmediatamente. No hay tiempo para ponerse a buscar la causa raíz.</span>
</div>
<br>
<p>
  Eso es verdad, hay que hacer todo lo posible por garantizar la continuidad de la producción.
  Pero se ha producido un problema y hay que resolverlo de forma definitiva. Las acciones que ha realizado
  para mantener la producción no son probablemente acciones de resolución, sino que son
  lo que llamamos "contramedidas inmediatas" o "acciones de emergencia", y no hacen sino corregir los síntomas del problema.<br>
  Más tarde ese mismo día, o al día siguiente, el equipo debe pararse a examinar el problema valiéndose de los "cinco por qué".
</p>
<div class="ia-sensei-example">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${bulbMedium}"></path></svg>
  <div class="example-title">Tomemos el ejemplo del fusible:</div>
  Una máquina esencial para la producción acaba de pararse.<br>
  <i>1. ¿Por qué se ha parado la máquina?</i><br>Ha habido una sobrecarga y se ha fundido el fusible.<br>
  <i>2. ¿Por qué se produjo la sobrecarga?</i><br>Uno de los rodillos de refrigeración no estaba lo suficientemente lubricado, lo que ralentizó la refrigeración.<br>
  <i>3. ¿Por qué el rodillo no estaba lo suficientemente lubricado?</i><br>La bomba de lubricación iba demasiado lenta.<br>
  <i>4. ¿Por qué iba lenta la bomba?</i><br>El árbol de la bomba estaba desgastado y traqueteaba a causa de la presencia de fragmentos de metal.<br>
  <i>5. ¿Por qué había fragmentos de metal golpeando el árbol?</i><br>La bomba necesita un filtro adecuado y no lo tenía.<br>
</div>
<p>
  Si pensamos en este ejemplo, resulta bastante claro que sin un estudio más completo y sin
  el uso de la herramienta de los "cinco por qué", esa sobrecarga volvería a producirse regularmente.
  El objetivo de la herramienta de los "cinco por qué" es identificar una causa raíz, que se ha de
  erradicar para que el problema no vuelva a producirse nunca más, ni en su equipo ni en otro distinto.<br>
  La herramienta de los "cinco por qué" de Shizen es una excelente herramienta para llevar a cabo este estudio.
</p>
<h2 class="basic-sub-title">
  Identificar causas reales
</h2>
<p>
  Al igual que hace al señalar problemas, debe asegurarse de que las causas sean reales.
  Y, sobre todo, es preciso utilizar datos específicos para demostrarlo. Para ello, Shizen le
  permite tomar fotos o añadir otros tipos de archivos adjuntándolos a la causa.<br>
  En el ejemplo anterior, la mayoría de las causas identificadas requieren una fotografía.<br><br>
  Aprenderá rápidamente más cosas sobre la herramienta de los "cinco por qué" si la prueba.
  No dude en consultar también la herramienta "Ishikawa".
  Las causas que añada en una herramienta aparecerán en la otra.
</p>
`;

const FIVE_WHYS_TITLE = '5 por qué';

export default {
  FIVE_WHYS,
  FIVE_WHYS_TITLE,
};
